var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateProductsPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Percent"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12.6663 3.3335L3.33301 12.6668M5.99967 4.66683C5.99967 5.40321 5.40272 6.00016 4.66634 6.00016C3.92996 6.00016 3.33301 5.40321 3.33301 4.66683C3.33301 3.93045 3.92996 3.3335 4.66634 3.3335C5.40272 3.3335 5.99967 3.93045 5.99967 4.66683ZM12.6663 11.3335C12.6663 12.0699 12.0694 12.6668 11.333 12.6668C10.5966 12.6668 9.99967 12.0699 9.99967 11.3335C9.99967 10.5971 10.5966 10.0002 11.333 10.0002C12.0694 10.0002 12.6663 10.5971 12.6663 11.3335Z",
    stroke: "#7B7B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateProductsPercent);
export default __webpack_public_path__ + "static/media/affiliate-products-percent.2ee008cf00433acf42575c352e9b7b8e.svg";
export { ForwardRef as ReactComponent };